import React from 'react';

import { SvgProps } from '../enums';

export const FlagVI: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55179"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55179)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#F7FCFF"
      />
      <mask
        id="mask1_270_55179"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_55179)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M8.5736 2.9635C8.5736 3.05575 8.99479 4.35253 8.99479 4.35253H6.95079L7.52534 3.23141C7.52534 3.23141 7.60926 3.01749 7.40381 2.9635C7.19835 2.9095 6.95079 3.14233 6.95079 3.14233C6.95079 3.14233 7.01119 2.76984 7.0919 2.68915C7.17261 2.60847 7.64435 2.40161 8.03755 2.40161C8.43075 2.40161 8.5736 2.87124 8.5736 2.9635ZM1.38859 2.43476C1.54541 2.36747 3.13906 2.84237 4.33284 3.19811L4.33286 3.19811L4.33287 3.19812L4.33287 3.19812C5.01935 3.40268 5.5736 3.56784 5.64636 3.56784C5.84565 3.56784 6.66581 4.41112 6.66581 4.41112V6.29699C6.66581 6.29699 4.07721 5.75968 1.63559 3.1115C1.2775 2.7569 1.14159 2.54075 1.38859 2.43476ZM6.42187 6.41595C6.42187 6.41595 6.15037 6.60302 5.85 7.10396C5.70223 7.35038 5.69034 7.56747 5.68174 7.72445C5.67285 7.88657 5.66749 7.98458 5.51958 7.98458C5.34693 7.98458 5.22167 8.02192 5.11972 8.05232C5.04976 8.07318 4.99078 8.09076 4.935 8.09076C4.79793 8.09076 4.53475 8.60818 4.66634 8.72792C4.79793 8.84767 5.34929 9.03852 5.34929 8.72792C5.34929 8.41733 5.49759 8.24088 5.76706 8.24088C6.03652 8.24088 6.51818 8.06246 6.51818 7.67098C6.51818 7.2795 7.04334 7.30746 7.04334 7.30746L6.42187 6.41595ZM11.7806 3.19811C12.9744 2.84237 14.5681 2.36747 14.7249 2.43476C14.9719 2.54075 14.836 2.7569 14.4779 3.1115C13.5191 4.82721 9.44765 6.29699 9.44765 6.29699V4.41112C9.44765 4.41112 10.2678 3.56784 10.4671 3.56784C10.5399 3.56784 11.0941 3.4027 11.7805 3.19814L11.7805 3.19814L11.7806 3.19811L11.7806 3.19811ZM9.69159 6.41595C9.69159 6.41595 9.96309 6.60302 10.2635 7.10396C10.4112 7.35038 10.4231 7.56747 10.4317 7.72445C10.4406 7.88657 10.446 7.98458 10.5939 7.98458C10.7665 7.98458 10.8918 8.02192 10.9937 8.05232C11.0637 8.07318 11.1227 8.09076 11.1785 8.09076C11.3155 8.09076 11.5787 8.60818 11.4471 8.72792C11.3155 8.84767 10.7642 9.03852 10.7642 8.72792C10.7642 8.41733 10.6159 8.24088 10.3464 8.24088C10.0769 8.24088 9.59528 8.06246 9.59528 7.67098C9.59528 7.2795 9.07012 7.30746 9.07012 7.30746L9.69159 6.41595ZM6.25419 8.50148C6.25419 8.3305 7.07522 7.41866 7.07522 7.41866L7.99255 7.03154C7.99255 7.03154 7.99727 7.1189 8.00429 7.26397C8.01132 7.1189 8.01603 7.03154 8.01603 7.03154L8.93336 7.41866C8.93336 7.41866 9.75439 8.3305 9.75439 8.50148C9.75439 8.67245 8.1797 10.0657 8.01603 10.0657C8.01191 10.0657 8.008 10.0638 8.00429 10.0601C8.00058 10.0638 7.99667 10.0657 7.99255 10.0657C7.82888 10.0657 6.25419 8.67245 6.25419 8.50148Z"
          fill="#E8AA00"
        />
        <path
          // eslint-disable-next-line max-len
          d="M3.12323 5.49618L4.07205 5.18036C4.71333 7.10693 5.33152 8.35226 5.88713 8.89044L5.19138 9.60873C4.4882 8.9276 3.81199 7.5654 3.12323 5.49618Z"
          fill="#46A000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M14.3458 5.16931H13.2772C13.2772 5.16931 13.5037 5.16931 13.5286 5.38817C13.5286 5.38817 13.5338 7.23513 13.5286 7.38024C13.5234 7.52536 13.2772 7.57473 13.2772 7.57473C13.2772 7.57473 14.5736 7.57868 14.3458 7.57473C14.1181 7.57077 14.0678 7.38024 14.0678 7.38024V5.38817C14.0678 5.21953 14.3458 5.16931 14.3458 5.16931ZM2.28267 7.42665C2.16171 7.11435 1.41486 5.2021 1.41486 5.2021H2.15422C2.02578 5.2021 1.97809 5.36559 1.97809 5.36559L2.49598 6.84222C2.49598 6.84222 2.99678 5.63664 2.99678 5.42286C2.99678 5.20907 2.78655 5.2021 2.78655 5.2021H3.75048L3.51761 5.27987C3.51761 5.27987 2.74632 7.04811 2.74632 7.42665C2.70956 7.51056 3.10142 7.56637 3.10142 7.56637H2.06633L2.28267 7.42665ZM11.1333 6.72834L11.7061 5.67289L11.723 6.84721L11.5455 6.78963L11.4197 7.57379L12.0532 6.35898L11.8423 6.27973L12.6264 5.43091L12.3594 6.57816L12.2074 6.44435L11.3091 8.12048L12.3118 6.97164L12.1185 6.87511L13.1087 6.22683L12.6776 7.28326L12.4371 7.11014L11.4197 8.391L10.9977 8.22872L11.4197 6.72834H11.1333ZM10.8025 8.73H10.4858V8.97094H10.2364L9.53019 9.79017H9.91998L10.0554 10.2514L10.2364 10.0887V10.2514L10.5904 10.0887L10.9289 10.3817L11.1814 9.2552L11.0114 9.13041L11.0987 9.05406L11.0114 8.73H10.8025Z"
          fill="#0093E1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M6.17176 4.00641C6.17176 4.00641 6.63706 4.32769 7.10235 4.32769C7.56765 4.32769 8.03294 4.00641 8.03294 4.00641C8.03294 4.00641 8.49823 4.32769 8.96353 4.32769C9.42882 4.32769 9.89412 4.00641 9.89412 4.00641V5.45685C9.89412 6.95656 8.03294 8.11886 8.03294 8.11886C8.03294 8.11886 6.08165 7.05165 6.17176 5.43904V4.00641Z"
          fill="#F7FCFF"
        />
        <mask
          id="mask2_270_55179"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="6"
          y="4"
          width="4"
          height="5"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M6.17176 4.00641C6.17176 4.00641 6.63706 4.32769 7.10235 4.32769C7.56765 4.32769 8.03294 4.00641 8.03294 4.00641C8.03294 4.00641 8.49823 4.32769 8.96353 4.32769C9.42882 4.32769 9.89412 4.00641 9.89412 4.00641V5.45685C9.89412 6.95656 8.03294 8.11886 8.03294 8.11886C8.03294 8.11886 6.08165 7.05165 6.17176 5.43904V4.00641Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_270_55179)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.03998 3.91003H9.95998V5.42007H6.03998V3.91003Z"
            fill="#2E42A5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M6.79767 5.42004H6.46826V8.47225H6.79767V5.42004ZM7.35767 5.42004H7.02826V8.47225H7.35767V5.42004ZM7.58826 5.42004H7.91767V8.47225H7.58826V5.42004ZM8.47767 5.42004H8.14826V8.47225H8.47767V5.42004ZM8.70826 5.42004H9.03767V8.47225H8.70826V5.42004ZM9.59767 5.42004H9.26826V8.47225H9.59767V5.42004Z"
            fill="#AF0100"
          />
        </g>
      </g>
    </g>
  </svg>
);
